import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import cogoToast from "cogo-toast";
import { kaReducer, Table } from "ka-table";
import { loadData, updateData, search } from "ka-table/actionCreators";
import { ActionType, SortingMode, PagingPosition } from "ka-table/enums";
import PatientService from "../services/patient-service";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import { kaPropsUtils } from 'ka-table/utils';
import { deselectAllRows, selectAllRows, selectRow, deselectRow } from "ka-table/actionCreators";
import RAndR from "./Claims/R&R";
import RollOver from "./Claims/RollOvers";


const tablePropsInitOrderDetails = {
    columns: [
        {
            key: 'selection-cell',
            isFilterable: false,
        },
        { key: "fac_dcode", title: "Facility Code" },
        { key: "fil_rxf_number", title: "RX" },
        { key: "fil_seq_num", title: "Sequence" },
        { key: "fil_fil_date", title: "Fill Date" },
        { key: "drg_label_name", title: "Drug", style: { width: "200px" } },
        { key: "pat_name", title: "Patient name" },
    ],
    singleAction: loadData(),
    sortingMode: SortingMode.Single,
    rowKeyField: "fil_rxf_number",
    search: ({ searchText, rowData, column }) => {
        if (column.key === "passed") {
            return (
                (searchText === "false" && !rowData.passed) ||
                (searchText === "true" && rowData.passed)
            );
        }
    },
    paging: {
        enabled: true,
        pageIndex: 0,
        pageSize: 50,
        position: PagingPosition.Bottom,
    },
};
const tablePropsInitRejectedOrderDetails = {
    columns: [
        {
            key: 'selection-cell',
            isFilterable: false,
        },
        { key: "fac_dcode", title: "Facility Code" },
        { key: "fil_rxf_number", title: "RX" },
        { key: "fil_seq_num", title: "Sequence" },
        { key: "fil_fil_date", title: "Fill Date" },
        { key: "drg_label_name", title: "Drug", style: { width: "200px" } },
        { key: "pharmacy_name", title: "Pharmacy" },
        { key: "pat_name", title: "Patient name" },
    ],
    singleAction: loadData(),
    sortingMode: SortingMode.Single,
    rowKeyField: "fil_rxf_number",
    search: ({ searchText, rowData, column }) => {
        if (column.key === "passed") {
            return (
                (searchText === "false" && !rowData.passed) ||
                (searchText === "true" && rowData.passed)
            );
        }
    },
    paging: {
        enabled: true,
        pageIndex: 0,
        pageSize: 50,
        position: PagingPosition.Bottom,
    },
};

const tablePropsInitOldClaimDetails = {
    columns: [
        {
            key: 'selection-cell',
            isFilterable: false,
        },
        { key: "fac_code", title: "Facility Code" },
        { key: "rxf_number", title: "RX" },
        { key: "charge_code", title: "Charge Code" },
        { key: "fil_date", title: "Fill Date" },
        { key: "drug", title: "Drug", style: { width: "200px" } },
       
        { key: "pat_name", title: "Patient name" },
        { key: "tcg", title: "TCG" },
    ],
    singleAction: loadData(),
    sortingMode: SortingMode.Single,
    rowKeyField: "fil_id",
    search: ({ searchText, rowData, column }) => {
        if (column.key === "passed") {
            return (
                (searchText === "false" && !rowData.passed) ||
                (searchText === "true" && rowData.passed)
            );
        }
    },
    paging: {
        enabled: true,
        pageIndex: 0,
        pageSize: 50,
        position: PagingPosition.Bottom,
    },
};

const tablePropsInitOldRejectedClaimDetails = {
    columns: [
        {
            key: 'selection-cell',
            isFilterable: false,
        },
        { key: "fac_code", title: "Facility Code" },
        { key: "rxf_number", title: "RX" },
        { key: "charge_code", title: "Charge Code" },
        { key: "fil_date", title: "Fill Date" },
        { key: "drug", title: "Drug", style: { width: "200px" } },
        { key: "pharmacy_name", title: "Pharmacy" },
        { key: "pat_name", title: "Patient name" },
        { key: "tcg", title: "TCG" },
    ],
    singleAction: loadData(),
    sortingMode: SortingMode.Single,
    rowKeyField: "fil_id",
    search: ({ searchText, rowData, column }) => {
        if (column.key === "passed") {
            return (
                (searchText === "false" && !rowData.passed) ||
                (searchText === "true" && rowData.passed)
            );
        }
    },
    paging: {
        enabled: true,
        pageIndex: 0,
        pageSize: 50,
        position: PagingPosition.Bottom,
    },
};


const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr;
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
};

const ClaimSubmission = ({ history }) => {
    const [loading, setLoading] = useState(false);
    const [tabIndex, setTabIndex] = useState(1);
    const [tablePropsOrderDetails, changeTablePropsOrderDetails] = useState(tablePropsInitOrderDetails);
    const [tablePropsRejectedOrderDetails, changeTablePropsRejectedOrderDetails] = useState(tablePropsInitRejectedOrderDetails);
    const [orderList, setOrderList] = useState([]);

    const [tablePropsOldClaimsDetails, changeTablePropsOldClaimsDetails] = useState(tablePropsInitOldClaimDetails);
    const [oldClaimOrderList, setOldClaimOrderList] = useState([]);
    const [tablePropsRejectedOldClaimsDetails, changeTablePropsRejectedOldClaimsDetails] = useState(tablePropsInitOldRejectedClaimDetails);
    const [rejectedOldClaimOrderList, setRejectedOldClaimOrderList] = useState([]);

    const [rxCode , setRxCode] = useState("");
    const [sequence , setSequence] = useState("");
    const [error , setError] = useState(false);

    const onSubmit = async () => {
        try {
          if (rxCode?.length === 0 || sequence?.length === 0 || Number(sequence) < 0 ) {
            setError(true);
            return;
          }
          let data = {};
          setLoading(true);
          data["rx_num"] = rxCode;
          data["seq_num"] = sequence;
          const resp =  await PatientService.submitReverseClaim(data);
          if(resp?.message) {
            throw new Error(resp.message);
          }
          setSequence("");
          setRxCode("");
          setError(false);
          setLoading(false);
        } catch (e) {
          const { hide } = cogoToast.error(
            e.message ? e.message : "Error submitting details. Please try after sometime.",
            {
              hideAfter: 15,
              onClick: () => {
                hide();
              },
            }
          );
          setLoading(false);
        }
      };


    const SelectionCell = ({ rowKeyValue, isSelectedRow, selectedRows }) => {
        return (
            <input
                type='checkbox'
                checked={isSelectedRow}
                onChange={(event) => {
                    if (event.currentTarget.checked) {
                        dispatch(selectRow(rowKeyValue));
                    } else {
                        dispatch(deselectRow(rowKeyValue));
                    }
                }}
            />
        );
    };

    const [allselect, setAllselect] = useState(false);
    const SelectionHeader = (props) => {
        return (
            <input
                type='checkbox'
                checked={allselect}
                onChange={(event) => {
                    if (event.currentTarget.checked) {
                        dispatch(selectAllRows());
                        setAllselect(true);
                    } else {
                        dispatch(deselectAllRows());
                        setAllselect(false);
                    }
                }}
            />
        );
    };


    const SelectionCellRejected = ({ rowKeyValue, isSelectedRow, selectedRows }) => {
        return (
            <input
                type='checkbox'
                checked={isSelectedRow}
                onChange={(event) => {
                    if (event.currentTarget.checked) {
                        dispatchRejected(selectRow(rowKeyValue));
                    } else {
                        dispatchRejected(deselectRow(rowKeyValue));
                    }
                }}
            />
        );
    };

    const [allselectRejected, setAllselectRejected] = useState(false);
    const SelectionHeaderRejected = (props) => {
        return (
            <input
                type='checkbox'
                checked={allselectRejected}
                onChange={(event) => {
                    if (event.currentTarget.checked) {
                        dispatchRejected(selectAllRows());
                        setAllselectRejected(true);
                    } else {
                        dispatchRejected(deselectAllRows());
                        setAllselectRejected(false);
                    }
                }}
            />
        );
    };

    const OldClaimsSelectionCell = ({ rowKeyValue, isSelectedRow, selectedRows }) => {
        return (
            <input
                type='checkbox'
                checked={isSelectedRow}
                onChange={(event) => {
                    if (event.currentTarget.checked) {
                        dispatchOldClaims(selectRow(rowKeyValue));
                    } else {
                        dispatchOldClaims(deselectRow(rowKeyValue));
                    }
                }}
            />
        );
    };

    const [allOldClaimsSelect, setOldClaimsAllselect] = useState(false);
    const OldClaimsSelectionHeader = (props) => {
        return (
            <input
                type='checkbox'
                checked={allOldClaimsSelect}
                onChange={(event) => {
                    if (event.currentTarget.checked) {
                        dispatchOldClaims(selectAllRows());
                        setOldClaimsAllselect(true);
                    } else {
                        dispatchOldClaims(deselectAllRows());
                        setOldClaimsAllselect(false);
                    }
                }}
            />
        );
    };

    const RejectedOldClaimsSelectionCell = ({ rowKeyValue, isSelectedRow, selectedRows }) => {
        return (
            <input
                type='checkbox'
                checked={isSelectedRow}
                onChange={(event) => {
                    if (event.currentTarget.checked) {
                        dispatchRejectedOldClaims(selectRow(rowKeyValue));
                    } else {
                        dispatchRejectedOldClaims(deselectRow(rowKeyValue));
                    }
                }}
            />
        );
    };

    const [allRejectedOldClaimsSelect, setRejectedOldClaimsAllselect] = useState(false);
    const RejectedOldClaimsSelectionHeader = (props) => {
        return (
            <input
                type='checkbox'
                checked={allRejectedOldClaimsSelect}
                onChange={(event) => {
                    if (event.currentTarget.checked) {
                        dispatchRejectedOldClaims(selectAllRows());
                        setRejectedOldClaimsAllselect(true);
                    } else {
                        dispatchRejectedOldClaims(deselectAllRows());
                        setRejectedOldClaimsAllselect(false);
                    }
                }}
            />
        );
    };

    const OldClaimsTCGCell = ({ rowData }) => {
        return (
            <span>
                {rowData?.tcg ? 'TCG' : ''}
            </span>
        );
    };

    const dispatch = async (action) => {
        changeTablePropsOrderDetails((prevState) => kaReducer(prevState, action));
        if (action.type === ActionType.LoadData) {
        }
    };

    const dispatchRejected = async (action) => {
        changeTablePropsRejectedOrderDetails((prevState) => kaReducer(prevState, action));
        if (action.type === ActionType.LoadData) {
        }
    };

    const dispatchOldClaims = async (action) => {
        changeTablePropsOldClaimsDetails((prevState) => kaReducer(prevState, action));
        if (action.type === ActionType.LoadData) {
        }
    };

    const dispatchRejectedOldClaims = async (action) => {
        changeTablePropsRejectedOldClaimsDetails((prevState) => kaReducer(prevState, action));
        if (action.type === ActionType.LoadData) {
        }
    };

    async function getOrderDetails(actnType) {
        try {
            setLoading(true);
            let resp = await PatientService.getScripts();
            dispatchRejectedOldClaims(deselectAllRows());
            dispatchOldClaims(deselectAllRows());
            dispatchRejected(deselectAllRows());
            dispatch(deselectAllRows());
            setRejectedOldClaimsAllselect(false);
            setOldClaimsAllselect(false);
            setAllselectRejected(false);
            setAllselect(false);
            setOrderList(resp.waitingList);
            dispatch(updateData(resp.waitingList));
            dispatchRejected(updateData(resp.rejectedList));
            setLoading(false);
        } catch (e) {
            setLoading(false);
        }
    }

    async function getOrderDetailsForOldClaims(actnType) {
        try {
            setLoading(true);
            dispatchRejectedOldClaims(deselectAllRows());
            dispatchOldClaims(deselectAllRows());
            setRejectedOldClaimsAllselect(false);
            setOldClaimsAllselect(false);
            let oldClaimResp = await PatientService.getOldClaimScripts();
            setOldClaimOrderList(oldClaimResp.oldClaimOrders);
            dispatchOldClaims(updateData(oldClaimResp.oldClaimOrders));
            setRejectedOldClaimOrderList(oldClaimResp.rejectedOldClaims);
            dispatchRejectedOldClaims(updateData(oldClaimResp.rejectedOldClaims));
            setLoading(false);
            setOldClaimRequested(true);
        } catch (e) {
            setLoading(false);
        }
    }
    useEffect(() => {
        getOrderDetails();
    }, []);
    const [oldClaimsrequested , setOldClaimRequested] =useState(false);
    useEffect(() => {
        if((tabIndex === 3 || tabIndex === 4) && !oldClaimsrequested)
            getOrderDetailsForOldClaims();
    }, [tabIndex]);
    const handleSubmit = async (props) => {
        try {
            const selectedFacs = kaPropsUtils.getSelectedData(props);
            if (selectedFacs?.length === 0) {
                const { hide } = cogoToast.error(
                    "Please select at least one record",
                    {
                        hideAfter: 15,
                        onClick: () => {
                            hide();
                        },
                    }
                );
                return;
            }
            setLoading(true);
            const selectedFillIds = selectedFacs.reduce((accumulator, currentValue) => {
                accumulator.push(currentValue.fil_id);
                return accumulator
            },
                [],
            );
            if (tabIndex === 3) {
                await PatientService.submitOldClaims(selectedFillIds);
            } else {
                await PatientService.submitClaims(selectedFillIds);
            }
            getOrderDetails();
            setLoading(false);
        } catch (e) {
            setLoading(false);
            const { hide } = cogoToast.error(
                "Error submitting data. Please try after sometime.",
                {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                }
            );
        }
    }

    const handleUploadRebillClaims = async (fileData) => {
        try {
            setLoading(true);
            await PatientService.submitRebillClaims(fileData);
            const { hide } = cogoToast.success(
                "File Uploaded Successfully",
                {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                }
            );
            setLoading(false);
        } catch (e) {
            setLoading(false);
            const { hide } = cogoToast.error(
                "Error submitting data. Please try after sometime.",
                {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                }
            );
        }
    };

    const handleUploadRollovers = async (fileData) => {
        try {
            setLoading(true);
            await PatientService.submitRollovers(fileData);
            const { hide } = cogoToast.success(
                "File Uploaded Successfully",
                {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                }
            );
            setLoading(false);
        } catch (e) {
            setLoading(false);
            const { hide } = cogoToast.error(
                "Error submitting data. Please try after sometime.",
                {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                }
            );
        }
    };

    return (
        <>
            <CipHeader />
            <div
                className={`inline-block customtop absolute ${loading ? "show" : "hidden"
                    }`}
            >
                <Loader
                    type="Oval"
                    color="#00BFFF"
                    height={50}
                    width={50}
                    timeout={300000} //3 secs
                />
            </div>
            <div className="bg-white w-5/6 mx-auto mt-6 mb-4 rounded shadow-md">
                <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
                    <div className="w-1/2 text-darkclr font-semibold leading-10 ">
                        <span className="text-xl">CLAIM SUBMISSIONS</span>
                    </div>
                </div>

                <ul
                    className={` p-2  mb-0 flex pt-3  flex-wrap flex `}
                    role="tablist"
                >  <li className="mr-2  text-center w-36 cursor-pointer pb-3">
                        <a
                            className={
                                "text-xs font-bold uppercase px-2 py-3 shadow-lg  block leading-normal w-36 rounded-t-lg " +
                                (tabIndex === 1 ? "text-black bg-header_bg" : "  bg-menu_active")
                            }
                            onClick={(e) => {
                                e.preventDefault();
                                setTabIndex(1);
                            }}
                            data-toggle="tab"
                            role="tablist"
                        >
                            WAITING CLAIMS
                        </a>
                    </li>
                    <li className="mr-2 text-center w-36 cursor-pointer">
                        <a
                            className={
                                "text-xs font-bold uppercase px-2 py-3 shadow-lg  block leading-normal w-36 rounded-t-lg " +
                                (tabIndex === 2 ? "text-black bg-header_bg" : "  bg-menu_active")
                            }
                            onClick={(e) => {
                                e.preventDefault();
                                setTabIndex(2);
                            }}
                            data-toggle="tab"
                            href="#link2"
                            role="tablist"
                        >
                            REJECTED CLAIMS
                        </a>
                    </li>
                    <li className="mr-2 text-center w-36 cursor-pointer">
                        <a
                            className={
                                "text-xs font-bold uppercase px-2 py-3 shadow-lg  block leading-normal w-36 rounded-t-lg " +
                                (tabIndex === 3 ? "text-black bg-header_bg" : "  bg-menu_active")
                            }
                            onClick={(e) => {
                                e.preventDefault();
                                setTabIndex(3);
                            }}
                            data-toggle="tab"
                            href="#link3"
                            role="tablist"
                        >
                            Old CLAIMS
                        </a>
                    </li>
                    <li className="mr-2 text-center w-46 cursor-pointer">
                        <a
                            className={
                                "text-xs font-bold uppercase px-3 py-3 shadow-lg  block leading-normal w-46 rounded-t-lg " +
                                (tabIndex === 4 ? "text-black bg-header_bg" : "  bg-menu_active")
                            }
                            onClick={(e) => {
                                e.preventDefault();
                                setTabIndex(4);
                            }}
                            data-toggle="tab"
                            href="#link4"
                            role="tablist"
                        >
                            REJECTED OLD CLAIMS
                        </a>
                    </li>
                    <li className="mr-2 text-center w-36 cursor-pointer">
                        <a
                            className={
                                "text-xs font-bold uppercase px-2 py-3 shadow-lg  block leading-normal w-36 rounded-t-lg " +
                                (tabIndex === 5 ? "text-black bg-header_bg" : "  bg-menu_active")
                            }
                            onClick={(e) => {
                                e.preventDefault();
                                setTabIndex(5);
                            }}
                            data-toggle="tab"
                            href="#link5"
                            role="tablist"
                        >
                            R & R
                        </a>
                    </li>
                    <li className="mr-2 text-center w-36 cursor-pointer">
                        <a
                            className={
                                "text-xs font-bold uppercase px-2 py-3 shadow-lg  block leading-normal w-36 rounded-t-lg " +
                                (tabIndex === 6 ? "text-black bg-header_bg" : "  bg-menu_active")
                            }
                            onClick={(e) => {
                                e.preventDefault();
                                setTabIndex(6);
                            }}
                            data-toggle="tab"
                            href="#link6"
                            role="tablist"
                        >
                            RollOvers
                        </a>
                    </li>
                    <li className="mr-2 text-center w-36 cursor-pointer">
                        <a
                            className={
                                "text-xs font-bold uppercase px-2 py-3 shadow-lg  block leading-normal w-36 rounded-t-lg " +
                                (tabIndex === 7 ? "text-black bg-header_bg" : "  bg-menu_active")
                            }
                            onClick={(e) => {
                                e.preventDefault();
                                setTabIndex(7);
                            }}
                            data-toggle="tab"
                            href="#link7"
                            role="tablist"
                        >
                            REVERSE CLAIM
                        </a>
                    </li>
                   
                    {tabIndex === 3 &&
                        <li className="ml-auto flex items-center pr-2">
                            <span className="relative">
                                <input
                                    type="search"
                                    defaultValue={tablePropsOldClaimsDetails.searchText}
                                    onChange={(event) => {
                                        dispatchOldClaims(search(event.currentTarget.value));
                                    }}
                                    placeholder=" Search"
                                    className="border rounded w-48 h-10 focus:outline-none focus:none pl-1 pr-8 font-light"
                                />
                                <img
                                    src="/img/search-2.svg"
                                    alt=""
                                    className="absolute w-4 h-4 right-2 top-3"
                                ></img>
                            </span>
                        </li>
                    }

                    {tabIndex === 4 &&
                        <li className="ml-auto flex items-center pr-2">
                            <span className="relative">
                                <input
                                    type="search"
                                    defaultValue={tablePropsRejectedOldClaimsDetails.searchText}
                                    onChange={(event) => {
                                        dispatchRejectedOldClaims(search(event.currentTarget.value));
                                    }}
                                    placeholder=" Search"
                                    className="border rounded w-48 h-10 focus:outline-none focus:none pl-1 pr-8 font-light"
                                />
                                <img
                                    src="/img/search-2.svg"
                                    alt=""
                                    className="absolute w-4 h-4 right-2 top-3"
                                ></img>
                            </span>
                        </li>
                    }
                </ul>

                {tabIndex === 1 && <div
                    className={`p-2 text-xs patientDetails gridList overflow-x-auto   `}
                >
                    <Table
                        className="table-fixed"
                        {...tablePropsOrderDetails}
                        childComponents={{
                            cellText: {
                                content: (props) => {
                                    // eslint-disable-next-line default-case
                                    switch (props.column.key) {
                                        case "selection-cell":
                                            return <SelectionCell {...props} />
                                        case "fil_fil_date":
                                            return <span>{formatDate(props.value)}</span>
                                    }
                                },
                            },
                            cell: {
                                elementAttributes: () => ({
                                    style: { textAlign: 'center' }
                                })
                            },
                            headCell: {
                                elementAttributes: () => ({
                                    style: { textAlign: 'center' }
                                }),
                                content: (props) => {
                                    if (props.column.key === 'selection-cell') {
                                        return <SelectionHeader {...props} />;
                                    }
                                },
                            },
                        }}
                        dispatch={dispatch}
                    />
                    <div
                        className={`p-2 text-xs patientDetails gridList overflow-x-auto flex  `}
                    >
                        <button
                            className={
                                orderList?.length === 0
                                    ? "opacity-50 cursor-not-allowed text-rounded font-medium h-10 text-white w-full bg-header_bg my-3 mr-4 focus:outline-none text-sm"
                                    : "rounded font-medium h-10 text-white w-full bg-header_bg my-3 focus:outline-none text-sm"
                            }
                            aria-label="Submit"
                            onClick={() => handleSubmit(tablePropsOrderDetails)}
                        >
                            SUBMIT
                        </button>
                    </div>
                </div>
                }
                {tabIndex === 2 && <div
                    className={`p-2 text-xs patientDetails gridList overflow-x-auto   `}
                >
                    <Table
                        className="table-fixed"
                        {...tablePropsRejectedOrderDetails}
                        childComponents={{
                            cellText: {
                                content: (props) => {
                                    // eslint-disable-next-line default-case
                                    switch (props.column.key) {
                                        case "selection-cell":
                                            return <SelectionCellRejected {...props} />
                                        case "fil_fil_date":
                                            return <span>{formatDate(props.value)}</span>
                                    }
                                },
                            },
                            cell: {
                                elementAttributes: () => ({
                                    style: { textAlign: 'center' }
                                })
                            },
                            headCell: {
                                elementAttributes: () => ({
                                    style: { textAlign: 'center' }
                                }),
                                content: (props) => {
                                    if (props.column.key === 'selection-cell') {
                                        return <SelectionHeaderRejected {...props} />;
                                    }
                                },
                            },
                        }}
                        dispatch={dispatchRejected}
                    />
                    <div
                        className={`p-2 text-xs patientDetails gridList overflow-x-auto flex  `}
                    >
                        <button
                            className={
                                orderList?.length === 0
                                    ? "opacity-50 cursor-not-allowed text-rounded font-medium h-10 text-white w-full bg-header_bg my-3 mr-4 focus:outline-none text-sm"
                                    : "rounded font-medium h-10 text-white w-full bg-header_bg my-3 focus:outline-none text-sm"
                            }
                            aria-label="Submit"
                            onClick={() => handleSubmit(tablePropsRejectedOrderDetails)}
                        >
                            SUBMIT
                        </button>
                    </div>
                </div>
                }

                {tabIndex === 3 && <div
                    className={`p-2 text-xs patientDetails gridList overflow-x-auto   `}
                >
                    <Table
                        className="table-fixed"
                        {...tablePropsOldClaimsDetails}
                        childComponents={{
                            cellText: {
                                content: (props) => {
                                    // eslint-disable-next-line default-case
                                    switch (props.column.key) {
                                        case "selection-cell":
                                            return <OldClaimsSelectionCell {...props} />
                                        case "tcg":
                                            return <OldClaimsTCGCell {...props} />
                                        case "fil_date":
                                            return <span>{formatDate(props.value)}</span>
                                    }
                                },
                            },
                            cell: {
                                elementAttributes: () => ({
                                    style: { textAlign: 'center' }
                                })
                            },
                            headCell: {
                                elementAttributes: () => ({
                                    style: { textAlign: 'center' }
                                }),
                                content: (props) => {
                                    if (props.column.key === 'selection-cell') {
                                        return <OldClaimsSelectionHeader {...props} />;
                                    }
                                },
                            },
                        }}
                        dispatch={dispatchOldClaims}
                    />
                    <div
                        className={`p-2 text-xs patientDetails gridList overflow-x-auto flex  `}
                    >
                        <button
                            className={
                                oldClaimOrderList?.length === 0
                                    ? "opacity-50 cursor-not-allowed text-rounded font-medium h-10 text-white w-full bg-header_bg my-3 mr-4 focus:outline-none text-sm"
                                    : "rounded font-medium h-10 text-white w-full bg-header_bg my-3 focus:outline-none text-sm"
                            }
                            aria-label="Submit"
                            onClick={() => handleSubmit(tablePropsOldClaimsDetails)}
                        >
                            SUBMIT
                        </button>
                    </div>
                </div>
                }

                {tabIndex === 4 && <div
                    className={`p-2 text-xs patientDetails gridList overflow-x-auto   `}
                >
                    <Table
                        className="table-fixed"
                        {...tablePropsRejectedOldClaimsDetails}
                        childComponents={{
                            cellText: {
                                content: (props) => {
                                    // eslint-disable-next-line default-case
                                    switch (props.column.key) {
                                        case "selection-cell":
                                            return <RejectedOldClaimsSelectionCell {...props} />
                                        case "tcg":
                                            return <OldClaimsTCGCell {...props} />
                                        case "fil_date":
                                            return <span>{formatDate(props.value)}</span>
                                    }
                                },
                            },
                            cell: {
                                elementAttributes: () => ({
                                    style: { textAlign: 'center' }
                                })
                            },
                            headCell: {
                                elementAttributes: () => ({
                                    style: { textAlign: 'center' }
                                }),
                                content: (props) => {
                                    if (props.column.key === 'selection-cell') {
                                        return <RejectedOldClaimsSelectionHeader {...props} />;
                                    }
                                },
                            },
                        }}
                        dispatch={dispatchRejectedOldClaims}
                    />
                    <div
                        className={`p-2 text-xs patientDetails gridList overflow-x-auto flex  `}
                    >
                        <button
                            className={
                                rejectedOldClaimOrderList?.length === 0
                                    ? "opacity-50 cursor-not-allowed text-rounded font-medium h-10 text-white w-full bg-header_bg my-3 mr-4 focus:outline-none text-sm"
                                    : "rounded font-medium h-10 text-white w-full bg-header_bg my-3 focus:outline-none text-sm"
                            }
                            aria-label="Submit"
                            onClick={() => handleSubmit(tablePropsRejectedOldClaimsDetails)}
                        >
                            SUBMIT
                        </button>
                    </div>
                </div>
                }

                {tabIndex === 5 &&
                    <div
                        className={`p-2 w-full h-60`}
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}
                    >
                        <RAndR onUpload={handleUploadRebillClaims} />
                    </div>
                }

                {tabIndex === 6 &&
                    <div
                        className={`p-2 w-full h-60`}
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}
                    >
                        <RollOver onUpload={handleUploadRollovers} />
                    </div>
                }

                {tabIndex === 7 && <div className="px-6 py-5 bg-white w-1/2 mx-auto ">
                    <ul className="text-left">
                        <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                            <label className="text-labelclr font-semibold text-sm tracking-wider">
                                RX Number
                            </label>
                            <span className="text-xs md:text-sm text-hlred ml-1">*</span>

                            <input
                                id="rxCode"
                                type="number"
                                placeholder="RX Number"
                                value={rxCode}
                                onChange={(e) => setRxCode(e.target.value)}
                                className={` ${error && rxCode === "" ? "border-red-400" : ""
                                    } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                            />

                            {error && rxCode === "" && (
                                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                                    You must specify RX number
                                </p>
                            )}
                        </li>
                        <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                            <label className="text-labelclr font-semibold text-sm tracking-wider">
                                Sequence Number
                            </label>
                            <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                            <input
                                id="sequence"
                                name="sequence"
                                type="number"
                                value={sequence}
                                placeholder="Sequence Number"
                                onChange={(e) => setSequence(e.target.value)}
                                className={` ${error && sequence === "" ? "border-red-400" : ""
                                    } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                            />

                            {error && sequence === "" && (
                                <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                                    You must specify sequence number
                                </p>
                            )}
                            {sequence !== "" && Number(sequence) < 0 && (
                                <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                                    Please enter a number greater than or equal to zero
                                </p>
                            )}
                        </li>

                        <li className="inline-block text-sm leading-8 w-full">
                            <button
                                className="rounded font-medium h-10 text-white w-full bg-login_btn my-3 focus:outline-none text-sm"
                                aria-label="Create"
                                onClick={() => onSubmit()}
                            >
                                SUBMIT
                            </button>
                        </li>
                    </ul>
                </div>
                }

        </div>
        </>
    );
};

export default withRouter(
    connect(
        () => ({}),
        (dispatch) => {
            return bindActionCreators({}, dispatch);
        }
    )(ClaimSubmission)
);